<div class="title-group">
	<div class="title-div">
		<img class="title-div-img" [src]="SelectedImageLibraryItem.ImageLibraryData_Thumb" />
	</div>

	<div class="title-div" style="margin-top: 5px">
		<label>{{ SelectedImageLibraryItem.ImageLibraryItemName }}</label>
	</div>
</div>

<div class="set-group">
	<!--		  -->
	<!-- Message  -->
	<!-- 		  -->
	<div class="set-group-item">
		<div style="margin-left: 10px">
			<label class="info-message" style="font-size: 14px">Note on making changes to district and school images:</label>
		</div>
	</div>

	<div class="set-group-item">
		<div style="margin-left: 10px">
			<label class="info-message"
				>When changing a school image to be a district image, make sure that no other schools have an image in this current image group with the same
				name. If they do then you will have to rename this image so that the name is unique across all schools in this group before setting this image
				as a district image.</label
			>
		</div>
	</div>

	<div class="set-group-item">
		<div style="margin-left: 10px">
			<label class="info-message"
				>When changing a district image to be a school image, keep in mind that if any other schools are using this image, then their associations can
				be lost. This could affect new ID Cards.</label
			>
		</div>
	</div>

	<div class="set-group-item">
		<div style="margin-left: 10px">
			<label class="info-message"
				>A good practice is to avoid changing a district image to a school image, but rather copy the image to the school under a new name.</label
			>
		</div>
	</div>

	<!--		      -->
	<!-- Check Boxes  -->
	<!-- 		      -->
	<div class="set-group-item">
		<div class="check-item">
			<div>
				<input class="check-item-check" type="checkbox" name="checkbox1" [(ngModel)]="isDistrictImage" ngDefaultControl />
			</div>

			<div style="margin-left: 10px">
				<label class="check-item-label">District Image</label>
			</div>

			<div style="margin-left: 20px">
				<input class="check-item-check" type="checkbox" name="checkbox2" [(ngModel)]="isImageLocked" ngDefaultControl [disabled]="isSU == false" />
			</div>

			<div style="margin-left: 10px">
				<label class="check-item-label">Image Locked</label>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="set-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" [disabled]="isBusy == true" (click)="onSet()">Ok</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
